import { all, fork } from 'redux-saga/effects';
import { watchCreateDependencySaga } from './sagas/create-dependency';
import { watchCreateMultipleSubTaskSaga } from './sagas/create-multiple-sub-tasks';
import { watchCreateSubTaskSaga } from './sagas/create-sub-task';
import { watchDeleteTaskByIdSaga } from './sagas/delete-task';
import { watchGetTaskByIdSaga } from './sagas/get-task';
import { watchRemoveAsSubtaskSaga } from './sagas/remove_as_subtask';
export const taskRootSaga = function*() {
    yield all([
        fork(watchGetTaskByIdSaga),
        fork(watchDeleteTaskByIdSaga),
        fork(watchCreateSubTaskSaga),
        fork(watchCreateMultipleSubTaskSaga),
        fork(watchCreateDependencySaga),
        fork(watchRemoveAsSubtaskSaga)
    ]);
};
